/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Height_QuestionInputs */

const en_us2_onboarding_height_question = /** @type {(inputs: Onboarding_Height_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How tall are you?`)
};

const pt_br2_onboarding_height_question = /** @type {(inputs: Onboarding_Height_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a sua altura?`)
};

const es_419_onboarding_height_question = /** @type {(inputs: Onboarding_Height_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuánto mides?`)
};

const pt_pt2_onboarding_height_question = /** @type {(inputs: Onboarding_Height_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a tua altura?`)
};

const fr_fr2_onboarding_height_question = /** @type {(inputs: Onboarding_Height_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combien mesures-tu ?`)
};

const de_de2_onboarding_height_question = /** @type {(inputs: Onboarding_Height_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie groß bist du?`)
};

const it_it2_onboarding_height_question = /** @type {(inputs: Onboarding_Height_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual è la tua altezza?`)
};

/**
* | output |
* | --- |
* | "How tall are you?" |
*
* @param {Onboarding_Height_QuestionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_height_question = /** @type {((inputs?: Onboarding_Height_QuestionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Height_QuestionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_height_question(inputs)
	if (locale === "es-419") return es_419_onboarding_height_question(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_height_question(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_height_question(inputs)
	if (locale === "de-DE") return de_de2_onboarding_height_question(inputs)
	if (locale === "it-IT") return it_it2_onboarding_height_question(inputs)
	return en_us2_onboarding_height_question(inputs)
});
export { onboarding_height_question as "onboarding.height.question" }